import { FieldLabel } from './field-label'
import * as S from './field-row.styled'
import type { FieldRowProps } from './field-row.types'

export const FieldRow = ({ children, photo, ...labelProps }: FieldRowProps) => {
  const Row = photo ? S.PhotoRow : S.FieldRow

  return (
    <Row>
      <FieldLabel {...labelProps} />
      {children}
    </Row>
  )
}
